'use client';
import Api from '@/api';
import { ResponseType, Blog, categoryType, brand, ServiceSubCategory } from '@/commonTypes';
import InfiniteContent from '@/components/general/InfiniteContent';
import ViewportWrapper from '@/components/structure/ViewportWrapper';
import React, { useEffect, useState } from 'react';

import { useTranslations } from 'next-intl';
import PageWrapper from '@/components/general/PageWrapper';

import blogStyle from './styles.module.css';

import { useSearchParams } from 'next/navigation';
import { useLayoutContext } from '@/context/LayoutContext';
// import BlogsFiltersSection from './BlogsFiltersSection';
import { PageHero } from '@/components/general/PageHero';
// import SearchHero from './SearchHero';
// import BlogCard from '../../home/HomeContent/SampleBlogs/BlogCard';
import styles from './styles.module.css';
// import BlogsAside from './BlogsAside';
import useWindowDimensions from '@/functions/useWindowDimensions';
import { mapBlog } from '@/functions/mapApiData';
import SearchHero from './SearchHero';
import SearchCategorySection from './SearchCategorySection';
import MainIcons from '@/icons/main';
import SearchContentInside from './SearchContentInside';
import { lightBg, lightBgIcon } from '@/functions/formats';
// import SearchFilters from './SearchFilters';
// import { Features } from '../../home/HomeContent/Features/Features';
// import BlogCard from '../../home/HomeContent/SampleBlogs/BlogCard';

interface ContentType {
  blogs?: ResponseType<Blog>;
  services?: ResponseType<ServiceSubCategory>;
  brands?: ResponseType<brand>;

  page?: string | number | null;
  limit?: number;
  params?: any;
  // category?: ResponseType<category>;
  activeCategory?: string | null;
  tagSlug?: string | null;
}

export default function SearchContent({
  blogs,
  services,
  brands,
  page,
  limit = 10,
  params,
  // category,
  activeCategory = '',
  tagSlug,
}: ContentType) {
  const tCommon = useTranslations('common');
  const searchParams = useSearchParams();
  const { checkIfLogin } = useLayoutContext();

  const [pageNumber, setPageNumber] = useState(page ? page : 1);
  //   const [list, setList] = useState({ response: items });
  const { width } = useWindowDimensions();
  const searchKey = 'q';

  const categories = [
    {
      id: 'all',
      title: 'همه',
      icon: <MainIcons.searchIcon />,
      count: Number(blogs?.count) + Number(brands?.count) + Number(services?.count) || 0,
      list: null,
    },
    {
      id: 'services',
      title: 'سرویس‌ها',
      icon: <MainIcons.ServiceIcon />,
      count: services?.count ? Number(services?.count) : 0,
      list: services?.response,
      href: '/allServices',
      backgroundIcon: lightBg(1),
      iconColor: lightBgIcon(1),
      moreText: 'همه سرویس‌ها',
      gridClass: 'grid_3',
    },
    {
      id: 'blogs',
      title: 'بلاگ‌ها',
      icon: <MainIcons.documentIcon />,
      count: blogs?.count ? Number(blogs?.count) : 0,
      list: blogs?.response,
      href: '/blogs',
      backgroundIcon: lightBg(0),
      iconColor: lightBgIcon(0),
      moreText: 'همه بلاگ‌ها',
      gridClass: 'grid_3',
    },
    {
      id: 'brands',
      title: 'برند‌ها',
      icon: <MainIcons.GlobeIcon />,
      count: brands?.count ? Number(brands?.count) : 0,
      list: brands?.response,
      href: '/brands',
      backgroundIcon: lightBg(2),
      iconColor: lightBgIcon(2),
      moreText: 'همه برندها',
      gridClass: 'grid_3',
    },
  ];

  const [activeMenu, setActiveMenu] = useState('all');

  useEffect(() => {
    setPageNumber(page ? page : 1);
  }, [page]);

  console.log('params====', params);
  const tags = [{ id: 1, title: 'تعویض روغن', count: 100 }];

  console.log('blogs==', blogs, brands, services);

  return (
    <>
      <PageWrapper>
        <ViewportWrapper className={`w-full`}>
          <PageHero className={`${styles.hero}`}>
            <SearchHero setPageNumber={setPageNumber} tags={tags} searchKey={searchKey} />
          </PageHero>
        </ViewportWrapper>
      </PageWrapper>
      <PageWrapper className={`w-full mt-0 section-light py-0`}>
        <ViewportWrapper className={`container py-0`}>
          <SearchCategorySection
            list={categories}
            activeMenu={activeMenu}
            setActiveMenu={setActiveMenu}
          />
        </ViewportWrapper>
      </PageWrapper>
      <PageWrapper className={`w-full mt-0 section-light py-0`}>
        <ViewportWrapper className={`container py-0`}>
          <SearchContentInside
            tags={tags}
            totalCount={categories?.filter((x) => x.id == activeMenu)?.[0]?.count}
            searchKey={searchKey}
            categories={categories}
            activeMenu={activeMenu}
          />
        </ViewportWrapper>
      </PageWrapper>
    </>
  );
}
